export default __webpack_public_path__ + "static/media/WhatsApp Image 2021-11-07 at 8.56.59 PM.57911b94.jpeg";